import ListDynamicI from '../types.ts';

const getItem: ListDynamicI['getItem'] = function (target) {
    const { prop } = this.props;

    return prop ? target[prop]!.toString() : target.toString();
};

export default getItem;
